export const prerender = true;
export const trailingSlash = 'always';

import type { LayoutLoad } from './$types.js';
import { LiveEndpoints } from '../src/utils/liveEndpoints';
import { appState } from '$lib/stores/index.svelte';
import enContent from '$locales/en/content.json';
import { getData } from '$utils/data';
import rngsioConfig from '../rngs-io.json';

export const load: LayoutLoad = async ({ url, fetch }) => {
  const liveEndpoints = new LiveEndpoints(rngsioConfig, url);
  const { story: content } = await liveEndpoints.getLiveContent(
    'en/content',
    enContent
  );

  const data = await getData({ fetch });
  appState.optaData = data;

  return { content, data };
};
